/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isOpen: false,
  loading: false,
  clientCode: null,
  editMode: false,
  noteId: null,
};

export const clientInfoSlice = createSlice({
  name: 'clientInfo',
  initialState,
  reducers: {
    setOpenClient: (state, action) => {
      state.isOpen = action.payload;
    },
    setLoadingClient: (state) => {
      state.loading = !state.loading;
    },
    setEditMode: (state, action) => {
      state.editMode = action.payload;
    },
    setClientCode: (state, action) => {
      state.clientCode = action.payload;
    },
    setClientInfo: (state, action) => {
      state.isOpen = action.payload.isOpen;
      state.clientCode = action.payload.clientCode;
      state.editMode = action.payload.editMode || false;
      state.noteId = action.payload.noteId || null;
    },
  },
});

export const {
  setOpenClient, setLoadingClient, setEditMode, setClientCode, setClientInfo,
} = clientInfoSlice.actions;

export default clientInfoSlice.reducer;
